export default {
  SHOW_INFO_NOTIFICATION: "SHOW_INFO_NOTIFICATION",
  SHOW_ERROR_NOTIFICATION: "SHOW_ERROR_NOTIFICATION",
  SHOW_WARNING_NOTIFICATION: "SHOW_WARNING_NOTIFICATION",
  CLEAR_NOTIFICATIONS: "CLEAR_NOTIFICATIONS"
};
